var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalckLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4892",
    "data-name": "Group 4892",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.701,
    height: 24.805,
    viewBox: "0 0 75.701 24.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3407",
    "data-name": "Group 3407",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3405",
    "data-name": "Group 3405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_146_",
    d: "M192.676,263.218l7.739-12.388h-5.138c-.367.612-.8,1.285-1.254,1.987-.459.735-.887,1.438-1.346,2.171s-.887,1.438-1.315,2.141-.856,1.346-1.224,1.927L185.03,250.8h-5.2c1.254,2.019,2.539,4.068,3.885,6.179s2.63,4.16,3.854,6.148L179.8,275.606h5.108l5.261-8.32,5.261,8.32h5.077Z",
    transform: "translate(-124.805 -250.8)",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    d: "M75.5,269.317a8.136,8.136,0,1,0,0,13.458v1.009h3.579V263.2H75.5Zm-4.588,10.889a4.16,4.16,0,1,1,4.16-4.16A4.16,4.16,0,0,1,70.909,280.206Z",
    transform: "translate(-43.595 -259.407)",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    d: "M13.734,281h0v6.3h0a4.878,4.878,0,0,1-9.727.214H3.976V281H0v6.515H0a8.851,8.851,0,0,0,17.679,0h0V281Z",
    transform: "translate(0 -271.763)",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    d: "M135.233,282h0v6.3h0a4.878,4.878,0,0,1-9.727.214h-.031V282H121.5v6.515h0a8.852,8.852,0,0,0,17.679,0h0V282Z",
    transform: "translate(-84.337 -272.457)",
    fill: "#272727"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalckLogo);
export default __webpack_public_path__ + "static/media/balckLogo.7f713c16c75dba79ba1b2f5c4ee677e8.svg";
export { ForwardRef as ReactComponent };